module.exports = __webpack_public_path__ + "fonts/NotoSans-Italic.516f235.woff2";